import EventEmitter from 'eventemitter3'

const ee = new EventEmitter()

export default ee
